import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNeo = function SvgNeo(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#EDF0F4",
        d: "M118.191 74.514c-8.013 32.143-40.569 51.705-72.716 43.69C13.342 110.19-6.22 77.632 1.797 45.492 9.807 13.345 42.363-6.218 74.5 1.795c32.144 8.014 51.705 40.575 43.691 72.72"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#00E599",
        d: "M28 37.271v46.825L58.394 95V47.795l32.881-12.12L61.433 25z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#00AF92",
        d: "M60.882 49.144V74.75l30.393 10.904V37.898z"
    })));
};

export { SvgNeo as ReactComponent };
//# sourceMappingURL=NEO.svg.es.js.map
